export default __webpack_public_path__ + "static/22-e6e284fd492baeeb64057f04d6d9b42a.jpg";